import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#FAF7F5] pt-20" data-id="element-133">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#F5F0EB] rounded-l-[100px] -z-10 hidden md:block" data-id="element-134" />
      <div className="absolute top-20 left-10 w-64 h-64 bg-[#E8D5D5] rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-135" />
      <div className="absolute bottom-20 right-10 w-64 h-64 bg-[#C9A96E] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" data-id="element-136" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-137">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-138">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center md:text-left" data-id="element-139">
            <span className="inline-block py-1 px-3 rounded-full bg-[#E8D5D5]/50 text-[#8B7E74] text-sm font-semibold tracking-wider mb-6" data-id="element-140">
              EST. 2020
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-[#3D3D3D] leading-tight mb-6" data-id="element-141">
              {t.hero.title}
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-lg mx-auto md:mx-0 leading-relaxed" data-id="element-142">
              {t.hero.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-143">
              <Button onClick={() => document.getElementById('calendar')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-144">
                {t.hero.cta}
              </Button>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-145">
            <div className="relative aspect-[4/5] rounded-t-[150px] rounded-b-[20px] overflow-hidden shadow-2xl" data-id="element-146">
              <img src="https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?q=80&w=2070&auto=format&fit=crop" alt="Beauty Salon Interior" className="w-full h-full object-cover" data-id="element-147" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3D3D3D]/20 to-transparent" data-id="element-148" />
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.6
          }} className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl max-w-[200px] hidden md:block" data-id="element-149">
              <div className="flex items-center gap-2 mb-2" data-id="element-150">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4 text-[#C9A96E] fill-current" viewBox="0 0 20 20" data-id="element-151">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-152" />
                  </svg>)}
              </div>
              <p className="text-sm text-gray-600 font-medium" data-id="element-153">
                "Best salon experience in the city!"
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}